import { Controller } from "stimulus";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
  connect() {
    // ── 1. Zoom-in reveal al entrar al viewport ──────────────────────────
    gsap.set(this.element, { opacity: 0, y: 60, scale: 0.78 });

    ScrollTrigger.create({
      trigger: this.element,
      start: "top 85%",
      once: true,
      onEnter: () => {
        gsap.to(this.element, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.9,
          ease: "power3.out",
          delay: this.delayValue,
        });
      },
    });

    // ── 2. Efecto parallax mientras se scrollea dentro de la section ─────
    gsap.to(this.element, {
      y: -30,
      scale: 1.06,
      ease: "none",
      scrollTrigger: {
        trigger: this.element.closest(".programas-img-area") || this.element,
        start: "top bottom",
        end: "bottom top",
        scrub: 1.2,
      },
    });
  }

  disconnect() {
    ScrollTrigger.getAll().forEach((st) => {
      if (st.vars.trigger === this.element || st.vars.trigger === this.element.closest(".programas-img-area")) {
        st.kill();
      }
    });
  }

  get delayValue() {
    return parseFloat(this.element.dataset.revealDelay || "0");
  }
}
